import block1Bg from './assets/block1Bg.jpg';
import block1BgM from './assets/block1BgM.jpg';
import block2Bg from './assets/block2Bg.jpg';
import block2BgM from './assets/block2BgM.jpg';

import block1MainImg from './assets/block1MainImg.jpg';
import block1MainImgM from './assets/block1MainImgM.jpg';
import block2MainImg from './assets/block2MainImg.jpg';
import block2MainImgM from './assets/block2MainImgM.jpg';

import block1tn1 from './assets/block1tn1.jpg';
import block1tn2 from './assets/block1tn2.jpg';
import block2tn1 from './assets/block2tn1.jpg';
import block2tn2 from './assets/block2tn2.jpg';

export const block1Data = {
  id: 'block1',
  header: 'From Jupiter, with Love',
  background: block1Bg,
  backgroundM: block1BgM,
  mainImg: block1MainImg,
  mainImgM: block1MainImgM,
  tn1: block1tn1,
  tn2: block1tn2,
  paragraph:
    'Bioastronautics researcher Kellie Gerardi is training to become one of a select group of future astronauts. But what makes Kellie’s story even more unique is that she is also a dedicated mother. Follow her journey as she trains for a 2023 space mission, seen through the eyes of her 4-year-old daughter, Delta.',
  paragraphM:
    'Bioastronautics researcher Kellie Gerardi is training to become one of a select group of future astronauts. But what makes Kellie’s story even more unique is that she is also a dedicated mother. Follow her journey as she trains for a 2023 space mission, seen through the eyes of her 4-year-old daughter, Delta.',
  link: 'https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/fromJupiter/',
  buttonCopy: 'watch film'
};
export const block2Data = {
  id: 'block2',
  header: 'Welcome to the club',
  background: block2Bg,
  backgroundM: block2BgM,
  mainImg: block2MainImg,
  mainImgM: block2MainImgM,
  tn1: block2tn1,
  tn2: block2tn2,
  paragraph:
    'Mother and bioastronautics researcher Kellie Gerardi shares her excitement for next year’s research mission, a feat that exemplifies the possibilities of space travel in the 21st century. In this film, Kellie and predecessor Sirisha Bandla tour Spaceport America®, New Mexico.',

  paragraphM:
    'Mother and bioastronautics researcher Kellie Gerardi shares her excitement for next year’s research mission, a feat that exemplifies the possibilities of space travel in the 21st century. In this film, Kellie and predecessor Sirisha Bandla tour Spaceport America®, New Mexico.',
  link: 'https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/welcomeToTheClub/',
  buttonCopy: 'watch now'
};
